/**
 * Slideshow autoplay starts on the visitor's first interaction.
 *
 * A hero that rotates during the initial load keeps changing the first
 * viewport, which pins Lighthouse's Speed Index at its worst. The compiled theme
 * bundle still builds the Flickity slider with the merchant's autoplay
 * duration, but the bundle does not expose the Flickity instance, so this
 * script uses Flickity's own pause-on-hover handling: as soon as a slider in a
 * `[data-autoplay-after-interaction]` slideshow activates (`flickity-enabled`),
 * it gets a synthetic `mouseenter` (player paused); the first interaction
 * (`skuOnFirstInteraction`, snippets/first-interaction.liquid) sends
 * `mouseleave` (player resumes). Drag-to-stop and tab-visibility handling stay
 * Flickity's.
 */
(function () {
  if (window.__skuSlideshowAutoplay) return;
  window.__skuSlideshowAutoplay = true;

  var SELECTOR = '[data-autoplay-after-interaction] .js-slideshow';
  var interacted = false;
  var paused = [];

  function hold(slider) {
    if (interacted || paused.indexOf(slider) !== -1) return;
    slider.dispatchEvent(new MouseEvent('mouseenter'));
    paused.push(slider);
  }

  function watch(slider) {
    if (slider.classList.contains('flickity-enabled')) {
      hold(slider);
      return;
    }
    var observer = new MutationObserver(function () {
      if (!slider.classList.contains('flickity-enabled')) return;
      observer.disconnect();
      hold(slider);
    });
    observer.observe(slider, { attributes: true, attributeFilter: ['class'] });
  }

  function watchAll(root) {
    var sliders = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < sliders.length; i++) watch(sliders[i]);
  }

  window.skuOnFirstInteraction(function () {
    interacted = true;
    paused.splice(0).forEach(function (slider) {
      slider.dispatchEvent(new MouseEvent('mouseleave'));
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    watchAll(event.target);
  });

  watchAll(document);
})();
